// extracted by mini-css-extract-plugin
export default {"container":"ToolsManagementSection_container__pRXTU","tabContent":"ToolsManagementSection_tabContent__F66Zv"};